import React from 'react';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import BodyClass from '@plone/volto/helpers/BodyClass/BodyClass';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import { formatMeetDay, getLiveStatus } from './liveStatus';

const MeetLink = ({ meet }) => (
  <UniversalLink href={flattenToAppURL(meet['@id'])}>
    {meet.title}
  </UniversalLink>
);

// Below the header on every page: the live meet, or the next one
const LiveBand = ({ content }) => {
  const status = getLiveStatus(content);
  if (!status) return null;
  const { live = [], next, live_results_url } = status;

  return (
    <div className="asaj-liveband" role="status" aria-live="polite">
      <div className="asaj-liveband-inner">
        <span className="asaj-ldot" aria-hidden="true" />
        {live.length > 0 ? (
          <>
            <BodyClass className="is-live" />
            <span className="asaj-liveband-text">
              <b>Live now:</b>{' '}
              {live.map((meet, index) => (
                <React.Fragment key={meet['@id']}>
                  {index > 0 && ', '}
                  <MeetLink meet={meet} />
                </React.Fragment>
              ))}
              .{' '}
              <a
                href={live_results_url}
                target="_blank"
                rel="noopener noreferrer"
              >
                Follow live results
              </a>
            </span>
          </>
        ) : (
          <>
            <span className="asaj-liveband-text asaj-hide-sm">
              <b>No meet is live right now.</b>
              {next && (
                <>
                  {' '}
                  Live results open {formatMeetDay(next.start)} for the{' '}
                  <MeetLink meet={next} />.
                </>
              )}
            </span>
            {/* Phones: the same, in one or two lines */}
            <span className="asaj-liveband-text asaj-show-sm">
              {next ? (
                <>
                  <b>Next meet:</b> {formatMeetDay(next.start)} ·{' '}
                  <MeetLink meet={next} />
                </>
              ) : (
                <b>No meet is live right now.</b>
              )}
            </span>
          </>
        )}
      </div>
    </div>
  );
};

export default LiveBand;
